import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { SEOHead } from '@/components/shared/SEOHead';
import { CommandPalette } from '@/components/data-standards/CommandPalette';

interface LayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
}

export function Layout({ children, hideFooter = false }: LayoutProps) {
  const location = useLocation();
  
  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead path={location.pathname} />
      <Navbar />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
      <CommandPalette />
    </div>
  );
}
